module.exports = function() {
  return new Worker(__webpack_public_path__ + "1f53c199e0a4e2458ff4.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/dymo-player/lib/worker-store/superstore-worker.js
// module id = 2074
// module chunks = 3